export const moduleText = {
  useAppointment: 'contractPlan.useAppointment.title',
  useSales: 'contractPlan.useSales.title',
  useClassTicket: 'contractPlan.useClassTicket.title',
  useEcommerce: 'contractPlan.useEcommerce.title',
  useMemberHistory: 'contractPlan.useMemberHistory.title',
  useCoupon: 'contractPlan.useCoupon.title',
  useMemberGame: 'contractPlan.useMemberGame.title',
}
